/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import Calendar from 'react-native-calendars/src/calendar';

import Icon from './Icon';
import { startOfWeek } from '../../support/locale';
import { themeColors } from './Constants';

type Props = {
  initialMonth?: {
    [key: string]: any;
  };
  enableOutsideDays?: boolean;
  modifiers?: {
    [key: string]: any;
  };
  selectedDates: Set<string>;
  availableDates?: Set<string>;
  isDateRange?: boolean;
  onDateClick?: (date: string) => void;
  onMonthChange?: (...args: Array<any>) => any;
};

type CalendarObject = {
  day: number;
  month: number;
  year: number;
  timestamp: number;
  dateString: string;
};

class DatePicker extends Component<Props> {
  render() {
    let markedDatesProps: ObjectOf<{
      selected: boolean;
      selectedColor?: string;
      disabled?: boolean;
      disableTouchEvent?: boolean;
      marked?: boolean;
      startingDay?: boolean;
      endingDay?: boolean;
      color?: string;
    }> = {};

    this.props.availableDates?.forEach((date) => {
      let dateString = date.slice(0, 10);
      markedDatesProps[dateString] = {
        selected: false,
        disabled: false,
        disableTouchEvent: false,
      };
    });
    /** selectedDates when DateRange should always have only 2 or fewer items */
    let dateRange = this.props.isDateRange
      ? Array.from(this.props.selectedDates)
      : undefined;
    if (dateRange && dateRange?.length > 0) {
      let dateRangeFromSelectedDates =
        dateRange.length === 2
          ? this._getDaysArray(dateRange[0], dateRange[1])
          : dateRange;
      let fullDateRange = new Set(dateRangeFromSelectedDates);

      fullDateRange.forEach((date) => {
        let dateString = date.slice(0, 10);
        markedDatesProps[dateString] = {
          selected: true,
          // disabled: false,
          // disableTouchEvent: false,
          color: themeColors.blue,
          startingDay: !!(dateRange?.[0] === date),
          endingDay: !!(dateRange?.[1] === date),
        };
      });
    } else {
      this.props.selectedDates.forEach((date) => {
        let dateString = date.slice(0, 10);
        markedDatesProps[dateString] = {
          selected: true,
          disabled: false,
          disableTouchEvent: false,
          selectedColor: themeColors.withOpacity.blue50,
        };
      });
    }

    return (
      <Calendar
        markingType={this.props.isDateRange ? 'period' : undefined}
        renderArrow={(direction) => <Arrow direction={direction} />}
        onDayPress={(day) => {
          this._handleDayClick(day);
        }}
        markedDates={markedDatesProps}
        disabledByDefault={!!this.props.availableDates}
        firstDay={startOfWeek}
      />
    );
  }

  _handleDayClick = (day: CalendarObject) => {
    let ISOdate = new Date(day.timestamp).toISOString();
    if (this.props.onDateClick) {
      this.props.onDateClick(ISOdate);
    }
  };
  _getDaysArray = function (start?: string, end?: string) {
    if (!start || !end) {
      return;
    }
    let arr = [];
    for (
      let dt = new Date(start);
      dt <= new Date(end);
      dt.setDate(dt.getDate() + 1)
    ) {
      arr.push(dt.toISOString());
    }
    return arr;
  };
}

function Arrow(props: { direction: 'left' | 'right' }) {
  return (
    <Icon
      name={props.direction === 'left' ? 'arrowLeft' : 'arrowRight'}
      size="M"
      color={themeColors.black}
    />
  );
}

export default DatePicker;
